<template>
  <div>
    <template v-if="addrid === '1024'">
      深圳倉：<br>
      提供普、特貨空運以及海快服務。<br>
      不論大小件都可以寄，提供多件合包集運服務。<br>
      免費倉儲時間：90天<br>
      低消：空運1公斤，不滿1公斤以1公斤計費。<br>
      海快5公斤，不滿5公斤以5公斤計費。<br>
      物流方式：空運-宅配/7-11超商取貨<br>
      海快-宅配<br>
      <br>
      ＊當空運包裹尺寸不符合超商要求時會轉寄備用宅配地址。<br>
      ＊海快不分普特貨，透過「能寄嗎？」查詢顯示可以海快的商品都能寄。
    </template>
    <template v-else-if="addrid === '1210'">
      上海倉：<br>
      僅提供海快服務。<br>
      可海快寄送的商品，不論大小件都可以寄，提供多件合包集運服務。<br>
      免費倉儲時間：365天<br>
      低消：海快5公斤，不滿5公斤以5公斤計費。<br>
      物流方式：海快-宅配<br>
      <br>
      ＊海快不分普特貨，透過「能寄嗎？」查詢顯示可以海快的商品都能寄。
    </template>
    <template v-else-if="addrid === '1598'">
      三明倉：<br>
      僅提供海快服務。<br>
      可海快寄送的商品，不論大小件都可以寄，提供多件合包集運服務。<br>
      免費倉儲時間：365天<br>
      低消：海快5公斤，不滿5公斤以5公斤計費。<br>
      物流方式：海快-宅配<br>
      <br>
      ＊海快不分普特貨，透過「能寄嗎？」查詢顯示可以海快的商品都能寄。
    </template>
    <template v-else-if="addrid === '1591'">
      福州倉：<br>
      僅提供海快、海真快服務。<br>
      可海快寄送的商品，不論大小件都可以寄，提供多件合包集運服務。<br>
      離海關監管倉近，可優先裝櫃。<br>
      免費倉儲時間：90天<br>
      低消：海快5公斤，不滿5公斤以5公斤計費。<br>
      物流方式：海快-宅配、海真快-自取<br>
      <br>
      ＊海快不分普特貨，透過「能寄嗎？」查詢顯示可以海快的商品都能寄。
    </template>
    <template v-else-if="addrid === 'sea'">
      東莞海運家具倉：<br>
      僅能承運不插電的家具。<br>
      免費倉儲時間：365天 <br>
      無低消，按實際重量計費<br>
      物流方式：海運-台灣各地倉庫需自取或自行聯絡物流取件，暫不提供台灣派件到門。
    </template>
    <template v-else-if="addrid === '1050'">
      海關監管倉：<br>
      原名「福建商務倉」，因位於海關監管倉內，且為方便與福州倉區分，更名為「海關監管倉」<br>
      專為商務用戶開設，僅提供海快服務。<br>
      主要用於商務件備貨離海關監管倉近，可優先裝櫃，隨時發貨。<br>
      免費倉儲時間：365天<br>
      低消：海快5公斤。<br>
      物流方式：海快-宅配<br>
      <br>
      ＊以收取商業件、批量貨、大貨、重貨，以及單件5公斤以上的包裹為主。<br>
      ＊不能合包集運，3件包裹合併下單就需要分3個宅配單號分別寄出。<br>
      ＊原包裝寄出不會再另外裝袋、二次包裝，請廠商要做好包裝。
    </template>
  </div>
</template>
<script>
export default {
  props: {
    addrid: String,
  }
}
</script>
